module.exports = __webpack_public_path__ + "img/produkterdkERST_Logo_NEG.06da6d09.svg";